module.exports = __webpack_public_path__ + "static/media/sack.8a18d935.svg";